import { Node } from 'tiptap'
export default class Schema extends Node {

    get name() {
        return 'schema'
    }

    get schema() {
        return {
            attrs: {
                'data-id': {},
                'data-href': {},
                'data-type': {},
            },
            inline: true,
            group: 'inline',
            selectable: true,
            draggable: true,
            parseDOM: [
                {
                    tag: 'span.scheme',
                    getAttrs: dom => ({
                        'data-type': dom.getAttribute('data-type') ? dom.getAttribute('data-type') : '',
                        'data-href': dom.getAttribute('data-href') ? dom.getAttribute('data-href') : '',
                        'data-id': dom.getAttribute('data-id') ? dom.getAttribute('data-id') : '',
                    }),
                },
            ],
            toDOM: node => {
                return [
                    'span',
                    {
                        'class': 'scheme',
                        'data-type': node.attrs['data-type'],
                        'data-href': node.attrs['data-href'],
                        'data-id': node.attrs['data-id'],
                        'clickprevent': '$emit(open,\''+node.attrs['data-href']+'\')',
                    },
                    ['span',
                    {
                        'class': 'text',
                    },
                    ]
                ]
            },
        }
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                href: {
                    get() {
                        return this.node.attrs['data-href']
                    },
                    set(href) {
                        this.updateAttrs({
                            'data-href':href,
                        })
                    },
                },
                type: {
                    get() {
                        return this.node.attrs['data-type']
                    },
                    set(type) {
                        this.updateAttrs({
                            'data-type':type,
                        })
                    },
                },
            },
            methods: {
                open(href) {
                    let  link = document.createElement('a');
                    link.setAttribute('href',href);
                    link.setAttribute('target','_blank');
                    link.click();
                },
            },
            template: `<span class="scheme" @click="open(href)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>`,
        }
    }

    commands({ type }) {
        return {
            schema: attrs => (state, dispatch) => {
                const preloadId = attrs.preload;
                let  preloadPos = false;
                state.tr.doc.descendants((node, pos) => {
                    if(node.type.name == 'image_preloader'){
                        if(preloadId == node.attrs['data-id']){
                            preloadPos = pos;
                        }
                    }
                })
                const { selection } = state
                const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
                const node = type.create(attrs)
                let transaction
                if(preloadPos){
                    transaction = state.tr.replaceWith(preloadPos,preloadPos+1, node)
                } else {
                    transaction = state.tr.insert(position  , node)
                }
                dispatch(transaction)
            },
        }
    }

}
